import axios from "@/config/http";
import ip from "../config/ip.js";

let base = ip.Ips.ip1;

/**
 * 查询
 * @param {*} params
 * @returns
 */
export const loadActivityPageApi = params => {
  return axios.get(`${base}/biz/activity/page`, { params: params });
};

/**
 * 查询详情
 */
export const getActivityInfoApi = id => {
  return axios.get(`${base}/biz/activity/`, { params: { id: id } });
};

/**
 * 保存
 * @param {*} data
 * @returns
 */
export const saveActivityInfoApi = data => {
  return axios.post(`${base}/biz/activity/save`, data);
};

/**
 * 删除
 */
export const delActivityApi = id => {
  return axios.get(`${base}/biz/activity/del`, { params: { id: id } });
};

//---------------------------------------------------------------------------------------------------------------------

/**
 * 保存渠道
 * @param {*} data
 * @returns
 */
export const saveActivityChannelApi = data => {
  return axios.post(`${base}/biz/activity/channel/save`, data);
};

/**
 * 删除渠道
 */
export const delActivityChannelApi = id => {
  return axios.get(`${base}/biz/activity/channel/del`, { params: { id: /*渠道ID*/id } });
};



// WEBPACK FOOTER //
// ./src/api/activity.js